import { Form, Input } from "antd";

const InputText = ({
  rules,
  placeholder,
  label,
  classname,
  wrapClassname,
  name,
  value,
  onChange,
  disabled,
  onBlur,
}) => {
  const handleChange = (e) => {
    onChange?.(name, e.target.value);
  };

  return (
    <Form.Item label={label} name={name} rules={rules}>
      <Input
        onBlur={() => onBlur?.()}
        disabled={disabled}
        placeholder={placeholder}
        onChange={handleChange}
      />
    </Form.Item>
  );
};

export default InputText;
